export enum Links {
  HOME = '/sipacdash',
  FORBIDDEN = '/sipacdash/forbidden',
  PROCESS = '/sipacdash/process',
  PROCESS_TYPE_FORM = '/sipacdash/process-type-form',
  COVENANT = '/sipacdash/covenant',
}

export enum Roles {
  DASH_SIPAC = 'sys_dashsipac-users',
}

export enum ProcessStatus {
  CONCLUDED = 1,
  ARCHIVE = 2,
  ACTIVE = 3,
  PENDING = 4,
  INVALID = 5,
}
